import { ListBulletsIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const BulletList = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ListBulletsIcon {...rest} size={Sizes[size]} color={fill} />;
};

BulletList.displayName = 'BulletList';
